import { FunctionComponent } from 'react';
import { HtmlEditor } from '@netiva/classifieds-ui';

import { useAppDispatch, useAppSelector } from '@/store';
import { adActions } from '@/store/ad';

export type HtmlInputProps = {
  id: number;
  useMarkdown?: boolean;
  allowImages?: boolean;
  allowLinks?: boolean;
  allowLists?: boolean;
};

export const HtmlInput: FunctionComponent<HtmlInputProps> = ({
  id,
  useMarkdown,
  allowImages,
  allowLinks,
  allowLists,
}) => {
  const dispatch = useAppDispatch();
  const { formData } = useAppSelector((state) => state.ad);

  const handleChange = (value: string) => {
    dispatch(adActions.updateFormData({ key: id, value: value }));
  };

  return (
    <HtmlEditor
      value={formData[id]?.value || ''}
      onChange={handleChange}
      useMarkdown={useMarkdown}
      allowImages={allowImages}
      allowLinks={allowLinks}
      allowLists={allowLists}
    />
  );
};
